import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { assetsApi } from 'core/api/assets.api';
import { setAxiosAuth } from 'utils';

export interface UseGetAssetsProps {
  sortType: string;
  sortOrder: string;
  searchTxt: string;
  pickupDate: string;
  returnDate: string;
  pickupTime: string;
  returnTime: string;
  availFlag: boolean;
  selAssetType: any[];
  selLocation: string | number;
  accessToken?: string;
}

export const useGetAssets = ({
  sortType,
  sortOrder,
  searchTxt,
  pickupDate,
  returnDate,
  pickupTime,
  returnTime,
  availFlag,
  selAssetType,
  selLocation,
  accessToken = '',
}: UseGetAssetsProps) => {
  setAxiosAuth(accessToken);

  return useQuery({
    queryKey: [
      queryKeys.assets,
      sortType,
      sortOrder,
      searchTxt,
      pickupDate,
      returnDate,
      pickupTime,
      returnTime,
      availFlag,
      selAssetType,
      selLocation,
    ],
    queryFn: async () => await assetsApi.getAssetsOptions(
      { sortType, sortOrder },
      searchTxt,
      pickupDate,
      returnDate,
      pickupTime,
      returnTime,
      availFlag,
      selAssetType,
      selLocation
    ),
    staleTime: 1000 * 60 * 1,
    enabled: Boolean(accessToken),
  });
}
